import * as Sentry from '@sentry/react';
import { defer } from 'lodash';

import config from '../configs/config';

const CONNECTION_RETRIES_BEFORE_TRIGGERING_ERROR_REPORT = 10;
let remainingTriesBeforeTriggeringErrorReport = CONNECTION_RETRIES_BEFORE_TRIGGERING_ERROR_REPORT;

function checkConnection() {
    if (!app.store.getState().session.hasAPIConnection) {
        app.api.misc.ping().catch(err => {
            remainingTriesBeforeTriggeringErrorReport -= 1;
            if (remainingTriesBeforeTriggeringErrorReport == 0) {
                Sentry.addBreadcrumb(`Failed to establish connection with API at ${config.apiURL}`);
                Sentry.captureException(err);
            }
            setTimeout(checkConnection, 1000);
        });
    }
}

defer(checkConnection);
